import styled, { keyframes } from "styled-components";

export const SaquesContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  padding: 40px;
  box-sizing: border-box;
  background-image: url("/textura.jpg");
  background-size: cover;
  background-attachment: fixed;
`;

export const ContentBox = styled.div`
  background: rgba(30, 30, 30, 0.9);
  backdrop-filter: blur(10px);
  border-radius: 8px;
  padding: 30px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.37);
`;

export const SaquesFirstContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
`;

export const AreaTitle = styled.h2`
  margin: 0;
  color: #e6aa3a;
  font-size: 28px;
`;

export const AddSaques = styled.button`
  background: #e6aa3a;
  color: #111;
  border: none;
  border-radius: 6px;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;
  &:hover {
    background: #ffc300;
    transform: translateY(-2px);
  }
`;

export const Filtros = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 30px;

  @media (min-width: 1024px) {
    flex-direction: row;
    align-items: flex-end;
  }
`;

export const SearchBar = styled.div`
  display: flex;
  flex: 1;

  input {
    flex-grow: 1;
    height: 45px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    background: rgba(0, 0, 0, 0.3);
    padding: 0 20px;
    color: #fff;
    border-radius: 6px 0 0 6px;
    &:focus {
      outline: none;
      border-color: #e6aa3a;
    }
  }

  button {
    width: 60px;
    height: 45px;
    border: none;
    background: #e6aa3a;
    color: #111;
    cursor: pointer;
    border-radius: 0 6px 6px 0;
  }
`;

export const FiltroStatus = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 15px;
  flex: 2;

  .box {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .title {
    font-size: 12px;
    color: #e6aa3a;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 1px;
  }

  .selectBox {
    height: 45px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    background: rgba(0, 0, 0, 0.4);
    padding: 0 15px;
    color: #fff;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;

    &:focus {
      outline: none;
      border-color: #e6aa3a;
    }

    &::-webkit-calendar-picker-indicator {
      filter: invert(1);
      cursor: pointer;
    }
  }
`;

export const SaquesTable = styled.div``;
export const TableContainer = styled.div`
  width: 100%;
  overflow-x: auto;
  margin-top: 10px;

  &::-webkit-scrollbar {
    height: 8px;
  }
  &::-webkit-scrollbar-thumb {
    background: #e6aa3a;
    border-radius: 10px;
  }
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  min-width: 1000px;
`;

export const TableHeader = styled.thead``;
export const TableRow = styled.tr`
  color: rgba(255, 255, 255, 0.9);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  transition: background 0.2s;

  &:hover:not(:first-child) {
    background: rgba(255, 255, 255, 0.03);
  }

  &:first-child {
    background-color: rgba(0, 0, 0, 0.2);
    border-bottom: 2px solid #e6aa3a;
  }
`;

export const TableHeaderCell = styled.th`
  padding: 15px;
  text-align: left;
  white-space: nowrap;
  color: #fff;
  font-weight: 600;
  font-size: 14px;
`;

export const TableBody = styled.tbody``;
export const TableCell = styled.td`
  padding: 15px;
  text-align: left;
  white-space: nowrap;
  font-size: 14px;
`;

export const OptionsButtons = styled.div`
  display: flex;
  gap: 10px;

  button {
    border: none;
    border-radius: 6px;
    padding: 8px 12px;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s;
    color: #fff;
    text-transform: uppercase;

    &:hover {
      filter: brightness(1.2);
      transform: scale(1.05);
    }
  }
`;

export const ActionButton = styled.button`
  background: rgba(255, 255, 255, 0.05);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s;

  &:hover {
    background: #e6aa3a;
    color: #111;
    border-color: #e6aa3a;
  }
`;

const fadeIn = keyframes`from { opacity: 0; } to { opacity: 1; }`;
const slideIn = keyframes`from { transform: scale(0.95); opacity: 0; } to { transform: scale(1); opacity: 1; }`;

export const ModalConta = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.85);
  backdrop-filter: blur(8px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
  animation: ${fadeIn} 0.3s ease;
  padding: 20px;
  box-sizing: border-box;

  .box {
    background: #1a1a1a;
    border-radius: 12px;
    width: 100%;
    max-width: 500px;
    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.8);
    animation: ${slideIn} 0.4s ease-out;
    border: 1px solid #e6aa3a;
    position: relative;
    padding: 40px;
  }

  .title {
    margin: 0 0 20px 0;
    color: #e6aa3a;
    font-size: 24px;
    text-align: center;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    padding-bottom: 20px;
  }

  .close {
    position: absolute;
    top: 20px;
    right: 20px;
    background: transparent;
    border: none;
    color: #fff;
    font-size: 24px;
    cursor: pointer;
    opacity: 0.5;
    &:hover {
      opacity: 1;
      color: #e6aa3a;
    }
  }

  .account {
    color: #fff;
    display: flex;
    flex-direction: column;
    gap: 18px;

    .boxzinha {
      background: rgba(255, 255, 255, 0.03);
      padding: 12px;
      border-radius: 6px;
      font-size: 15px;
      border-left: 3px solid #e6aa3a;

      strong {
        color: #e6aa3a;
        margin-right: 10px;
        font-size: 13px;
        text-transform: uppercase;
      }
    }
  }
`;

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 40px;
  gap: 20px;
  color: #fff;
  font-size: 14px;

  span {
    opacity: 0.8;
  }
`;

export const PaginationButton = styled.button`
  background: rgba(255, 255, 255, 0.05);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  padding: 10px 20px;
  font-weight: 600;
  transition: all 0.3s;

  &:hover:not(:disabled) {
    background: #e6aa3a;
    color: #111;
    border-color: #e6aa3a;
  }
  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }
`;

export const SaquesContent = styled.div``;

export const GoldenStatus = styled.span`
  color: ${props => props.isGolden ? '#E6AA3A' : 'rgba(255,255,255,0.7)'};
  font-weight: ${props => props.isGolden ? '800' : '400'};
  text-transform: ${props => props.isGolden ? 'uppercase' : 'none'};
  ${props => props.isGolden && `
    text-shadow: 0 0 8px rgba(230, 170, 58, 0.4);
    letter-spacing: 1px;
  `}
`;